import axios from "axios";

// Utility function to extract the token from stored data
const retrieveStoredToken = () => localStorage.getItem("accessToken");

// Initializing Axios instance
const instance = axios.create({ withCredentials: true });

instance.interceptors.request.use(
  (config) => {
    // Attach JWT to the Authorization header
    const token = retrieveStoredToken();
    if (token !== null) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

instance.interceptors.response.use((response) => {
  // https://www.codemzy.com/blog/clients-reload-single-page-application-update
  if ("x-app-version" in response.headers) {
    const appVersion = localStorage.getItem("appVersion");
    if (appVersion !== response.headers["x-app-version"]) {
      if (appVersion !== null) {
        localStorage.setItem("version-update-needed", "true");
      }
      localStorage.setItem("appVersion", response.headers["x-app-version"]);
    }
  }
  return response;
});

export default instance;
